import React, { useCallback, useEffect, useState } from "react";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  IAgendamentoAlterarTipoForm,
  IAgendamentoAlterarTipoFormRHF,
  IAgendamentoCadastroForm,
  IReagendamentoProps,
} from "../../../types/agendamento";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { useContextSite } from "../../../context/Context";
import { TipoAtendimentoEnum } from "../../../enums/tipoAtendimento";
import { StatusAgendamentoEnum } from "../../../enums/statusAgendamento";
import { TipoClienteEnum } from "../../../enums/tipoCliente";

type ModalProps = {
  isOpen: boolean;
  reagendamento?: IReagendamentoProps;
};

export const useStore = () => {
  const [searchParams] = useSearchParams();
  const reagendamento = !!(searchParams.get("reagendamento") === "true");
  const [token] = useSessionStorage("@token");
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();
  const [usuario] = useSessionStorage("@usuarioMapa");
  const { uuidAgendamento } = useParams();
  const [modal, setModal] = useState<ModalProps>({ isOpen: false });
  const [tipoAtendimento, setTipoAtendimento] = useState<TipoAtendimentoEnum>(
    TipoAtendimentoEnum.LOJA
  );

  function submitReagendamentoForm(data: IReagendamentoProps) {
    const PAYLOAD: IReagendamentoProps = {
      ...data,
      uuidAgendamento: uuidAgendamento,
    };

    setModal({ isOpen: true, reagendamento: PAYLOAD });
  }

  function handleReagendamento() {
    setIsLoad(true);

    setModal({ isOpen: false });

    Agendamento.reagendar(modal?.reagendamento)
      .then(({ data }) => {
        toast.success("Reagendamento efetuado com sucesso!");

        setTimeout(() => {
          navigate(`/meus-agendamentos/agendamento?id=${data?.uuid}`);
        }, 2000);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  function submitAgendamento(data: IAgendamentoCadastroForm) {
    setIsLoad(true);

    Agendamento.postV2(data)
      .then(({ data }) => {
        if (token) {
          if (usuario?.tipo === TipoClienteEnum.DESPACHANTE) {
            navigate(`/agendamento/${data.uuid}/despachante-cliente`);
            return;
          }

          Agendamento.vincularAgendamentoAoCliente({
            uuid: data.uuid,
            uuidCliente: usuario?.uuidCliente,
          }).then(() => {
            navigate(`/agendamento/${data.uuid}/servicos`);
            return;
          });
        }

        // navigate(`/agendamento/${data.uuid}/login-cadastro`);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  function handleRescheduling(data: IAgendamentoAlterarTipoFormRHF) {
    const PAYLOAD: IAgendamentoAlterarTipoForm = {
      ...data,
      concessionaria: data?.concessionaria === "CONCESSIONARIA",
      uuid: uuidAgendamento,
    };

    setIsLoad(true);
    Agendamento.alterarTipoAtendimento(PAYLOAD)
      .then(({ data }) => {
        data?.status === StatusAgendamentoEnum.PAGO
          ? navigate(
              `/agendamento/${data?.uuid}/confirmar-horario?reagendamento=true`
            )
          : navigate(`/agendamento/${data?.uuid}/pagamento`);

        // Pagamento.gerarFatura({
        //   uuidAgendamento: PAYLOAD.uuid,
        //   formaPagamento: data?.fatura?.boleto
        //     ? FormaPagamentoEnum.BOLETO
        //     : FormaPagamentoEnum.PIX,
        // })
        //   .then(({ data: fatura }) => {
        //     if (fatura?.status === StatusAgendamentoEnum.PAGO) {
        //       setTimeout(() => {
        //         navigate(
        //           `/agendamento/${data?.uuid}/confirmar-horario?reagendamento=true`
        //         );
        //       }, 1000);
        //       return;
        //     }
        //     setTimeout(() => {
        //       navigate(`/agendamento/${data?.uuid}/pagamento`);
        //     }, 1500);
        //   })
        //   .catch(
        //     ({
        //       response: {
        //         data: { mensagem },
        //       },
        //     }) => toast.error(mensagem)
        //   );
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return {
    reagendamento,
    submitAgendamento,
    modal,
    setModal,
    submitReagendamentoForm,
    handleReagendamento,
    tipoAtendimento,
    handleRescheduling,
    setTipoAtendimento,
  };
};
